import React, { useState } from 'react';
import { useTranslation } from '@wix/cli-i18n';
import type { ValidScriptPlacements, ValidScriptTypes } from './const.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { generateEmbeddedScript } from './generate.js';
import { useProjectModel } from '../../../model.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';
import {
  ChooseScriptNameStep,
  ChooseScriptFolderStep,
  ChooseScriptTypeStep,
  ChooseScriptPlacementStep,
} from './steps.js';

export const useGenerateEmbeddedScript = () => {
  const { t } = useTranslation();
  const { model } = useProjectModel();
  const extensionType = t(
    'generate_command.flow.embedded_script'
  ).toLowerCase();

  const [scriptFolder, setScriptFolder] = useState<string>();
  const [scriptName, setScriptName] = useState<string>();
  const [scriptType, setScriptType] = useState<ValidScriptTypes>();
  const [scriptPlacement, setScriptPlacement] =
    useState<ValidScriptPlacements>();

  const generationTask = useGenerationTask(async () => {
    if (scriptFolder && scriptName && scriptType && scriptPlacement) {
      return generateEmbeddedScript(
        model.projectFolder,
        scriptFolder,
        scriptName,
        scriptType,
        scriptPlacement
      );
    }
  }, [scriptFolder, scriptName, scriptType, scriptPlacement]);

  return [
    <ChooseScriptNameStep onSubmit={setScriptName} scriptName={scriptName} />,
    <ChooseScriptFolderStep
      onSubmit={setScriptFolder}
      scriptName={scriptName}
      scriptFolder={scriptFolder}
    />,
    <ChooseScriptTypeStep onSubmit={setScriptType} />,
    <ChooseScriptPlacementStep onSubmit={setScriptPlacement} />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={extensionType}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-cli/supported-extensions/site-extensions/embedded-scripts/about-embedded-scripts-and-the-cli
        learnMoreUrl: 'https://wix.to/CDGhNZG',
      })}
    />,
  ];
};
